if (!customElements.get("landing-page-gallery")) {
  class LandingPageGallery extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.sliderContainer = this.querySelector(".landing-page-gallery-slider");
      this.sliderSettings = {
        wrapAround: true,
        pageDots: false,
        cellAlign: "left",
      };

      this.setupSlider();
    }

    disconnectedCallback() {}

    async setupSlider() {
      try {
        this.slider = await window.setupFlickity(
          this.sliderContainer,
          this.sliderSettings
        );
      } catch (error) {
        console.error(
          `❌ 👉🏻 LadingPageGallery | setupSlider | ${error.message}`
        );
        throw error;
      }
    }
  }

  customElements.define("landing-page-gallery", LandingPageGallery);
}
